module.exports = __webpack_public_path__ + "static/img/culture_01.dcb04bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/investCenter/culture_01.png
// module id = cT03
// module chunks = 0